<template lang="pug">
  div
    div.label.basic600--text.text-uppercase.mb-2 Sort {{ title }} by
    div.d-flex
      v-chip.button-AA-tiny(label small :outlined="sort === 'newest'" :color="sort === 'newest' ? 'info500' : 'basic300'" :style="sort === 'newest' ? `background-color: ${$vuetify.theme.themes[$theme].infoT08} !important` : ''" @click="sort = 'newest'") NEWEST
      v-chip.button-AA-tiny.ml-2(label small :outlined="sort === 'oldest'" :color="sort === 'oldest' ? 'info500' : 'basic300'" :style="sort === 'oldest' ? `background-color: ${$vuetify.theme.themes[$theme].infoT08} !important` : ''" @click="sort = 'oldest'") OLDEST
</template>

<script>
export default {
  name: 'PayoutSort',
  props: {
    parentSort: {
      type: String,
      required: true
    },
  },
  computed: {
    sort: {
      get () {
        return this.parentSort
      },
      set (newValue) {
        this.$emit('update:parentSort', newValue)
      }
    },
    title() {
      switch (this.$route.hash) {
        case '#toProcess':
          return 'commissions'

        case '#processing':
          return 'payouts'

        case '#completed':
          return 'payouts'
      
        default:
          return null
      }
    }
  }
}
</script>